import { render } from "./RoomHeader.vue?vue&type=template&id=5baff4c4"
import script from "./RoomHeader.vue?vue&type=script&lang=js"
export * from "./RoomHeader.vue?vue&type=script&lang=js"

import "./RoomHeader.vue?vue&type=style&index=0&id=5baff4c4&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__